import React from 'react';
import SafeHtml from './SafeHtml';

interface OfferDescriptionProps {
  text?: string | null;
  className?: string;
}

/**
 * 優惠詳情／細則顯示：有 HTML tag 就用 SafeHtml 渲染（已消毒），
 * 純文字就用 whitespace-pre-line 保留換行——兩種格式都兼容。
 */
const OfferDescription: React.FC<OfferDescriptionProps> = ({ text, className }) => {
  if (!text) return null;
  const hasHtml = /<[a-z][\s\S]*>/i.test(text);
  if (hasHtml) {
    return <SafeHtml html={text} className={className} />;
  }
  return <div className={`whitespace-pre-line ${className || ''}`}>{text}</div>;
};

export default OfferDescription;
